import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_HEALTH_INSURANCE_BY_ID } from './get-health-insurance-by-id.hook';


export const DELETE_HEALTH_INSURANCE_NUMBER_BY_ID = gql`
  mutation deleteHealthInsuranceById($id: String!) {
    deleteHealthInsuranceNumberById(id: $id) {
      _id
    }
  }
`;

export const useDeleteHealthInsuranceNumberById = ({
  onSuccess,
}: {
  onSuccess: () => void;
}) => {
  const { t } = useTranslation('settings');
  const [deleteHealthInsuranceNumberById] = useMutation(DELETE_HEALTH_INSURANCE_NUMBER_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteHealthInsuranceNumberById?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('healthInsurance.notifications.numberDeletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [
      GET_HEALTH_INSURANCE_BY_ID,
    ],
  });

  return deleteHealthInsuranceNumberById;
};
